import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';

class Produtos extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.PRODUTOS)
            return null;

        const categorias = this.props.produtosGerencia.categorias;

        if (!categorias)
            return;

        const token = this.props.token;

        const editorFields = [
            { "label": "Nome", "name": "name" },
            {
                "label": "Categoria",
                "name": "category.id",
                "type": "select",
                "options": categorias,
                "optionsPair": {
                    label: 'name',
                    value: 'id'
                }
            },
            {
                "label": "Preço (R$)",
                "name": "price",
                "type": "mask",
                "mask": "000.000.000.000.000,00",
                "maskOptions": {
                    "reverse": true,
                    "placeholder": "",
                },
                "data": function (row, type) {
                    return $.datatable.renders.number(".", ",", 2).display(row.price);
                }
            },
            {
                "label": "Estoque inicial",
                "name": "initialInventory"
            },
            {
                "label": "Ajuste de estoque",
                "name": "adjustInventory",
            },
        ];

        const editorCreateVisibleColumns = ['initialInventory'];
        const editorCreateHiddenColumns = ['adjustInventory'];
        const editorEditVisibleColumns = ['adjustInventory'];
        const editorEditHiddenColumns = ['initialInventory'];

        const datatablesColumns = [
            { data: "name", title: "Nome", render: $.datatable.renders.text() },
            { data: "price", title: "Preço (R$)", render: $.datatable.renders.money(".", ",", 2) },
            { data: "category.name", title: "Categoria", render: $.datatable.renders.text() },
            { data: "inventory", title: "Estoque", render: $.datatable.renders.number(".") },
            { data: "dateCreated", title: "Criação", render: $.datatable.renders.datetime(), width: 160 },
            { data: "dateUpdated", title: "Edição", render: $.datatable.renders.datetime(), width: 160 },
        ];

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/products/select',
            createUrl: '/api/products/insert',
            editUrl: '/api/products/update/_id_',
            removeUrl: '/api/products/delete/_id_',
        });

        const buttons = [
            {
                extend: 'csv',
                text: 'download',
                fieldSeparator: ';',
                filename: 'ProdutoEstoque',
                exportOptions: {
                    columns: [ 0, 1, 2, 3 ]
                }
            }
        ];

        const editorCreateTitle = 'Inserir produto';
        const editorEditTitle = 'Editar produto';
        const editorRemoveTitle = 'Remover produto';
        const editorRemoveMessage = 'Deseja remover este produto?';

        const domClassName = 'products-datatables';
        const title = 'Produtos';
        const subTitle = 'Gerenciamento';

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       responsive={true}
                       pageLength={100}
                       buttons={buttons}
                       editorCreateVisible={true}
                       editorCreate={callbacks.create.bind(callbacks)}
                       editorCreateTitle={editorCreateTitle}
                       editorCreateVisibleColumns={editorCreateVisibleColumns}
                       editorCreateHiddenColumns={editorCreateHiddenColumns}
                       editorEditVisible={true}
                       editorEdit={callbacks.edit.bind(callbacks)}
                       editorEditTitle={editorEditTitle}
                       editorEditVisibleColumns={editorEditVisibleColumns}
                       editorEditHiddenColumns={editorEditHiddenColumns}
                       editorRemoveVisible={true}
                       editorRemove={callbacks.remove.bind(callbacks)}
                       editorRemoveTitle={editorRemoveTitle}
                       editorRemoveMessage={editorRemoveMessage}
                       editorFields={editorFields}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
            />
        );
    }
}

export default Produtos;


// WEBPACK FOOTER //
// src/views/pages/Produtos.jsx